<template>
    <div class="elle-page-default">
        <CommonBuilder :data="data?.elements" />
    </div>
</template>

<script setup lang="ts">
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
});
</script>
